import React from 'react';
import {Dialog} from "@material-ui/core";

const ResetFinalizeScreen = () => {
    return (
        <Dialog open={true}>
            Go to your mailbox and click the link to reset password
        </Dialog>
    );
};

export default ResetFinalizeScreen;